import { apiClient } from './client';

export interface LoginPayload {
  username: string;
  password: string;
}

export interface LoginResponse {
  access: string;
  refresh: string;
  user: {
    id: number;
    email: string;
    username?: string;
    groups: string[];
    is_superuser: boolean;
  };
}

/**
 * 管理员登录
 * 后端路由: POST /api/auth/admin/login/
 * 限流: 5次/分钟
 */
export function adminLogin(payload: LoginPayload): Promise<LoginResponse> {
  return apiClient.post('/auth/admin/login/', payload);
}

/**
 * 普通用户登录 (备用)
 * 后端路由: POST /api/auth/login/password/
 */
export function userLogin(payload: LoginPayload): Promise<LoginResponse> {
  return apiClient.post('/auth/login/password/', payload);
}

export interface RefreshResponse {
  access: string;
  refresh?: string;
}

export function refreshToken(refresh: string): Promise<RefreshResponse> {
  return apiClient.post('/auth/token/refresh/', { refresh });
}

export function logout(): Promise<void> {
  return apiClient.post('/auth/logout/');
}
